// ========== Drawer Toggle ==========
document.addEventListener("click", function (event) {
  const drawerButton = event.target.closest(".drawer_menu_title");
  if (!drawerButton) return;

  const drawer = drawerButton.closest(".second_drawer_menu");
  const submenu = drawer?.querySelector(".submenu_main_blocker");
  if (!drawer || !submenu) return;

  // Close all others
  document.querySelectorAll(".second_drawer_menu.open_Mobile_menu").forEach((menu) => {
    if (menu !== drawer) {
      menu.classList.remove("open_Mobile_menu");
      const sub = menu.querySelector(".submenu_main_blocker");
      if (sub) sub.style.maxHeight = null;
    }
  });

  const isOpen = drawer.classList.toggle("open_Mobile_menu");
  submenu.style.maxHeight = isOpen ? `${submenu.scrollHeight}px` : null;
});

// ========== Dropdown Hover (Desktop Only) ==========
const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu && window.matchMedia("(hover: hover)").matches) {
  const dropdownItems = inlineMenu.querySelectorAll(".dropdown-item");
  const megaMenus = inlineMenu.querySelectorAll(".mega-menu");

  dropdownItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "true");
      document.body.classList.add("header_set");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.body.classList.remove("header_set");
    });
  });

  megaMenus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
      menu.setAttribute("open", "true");
      menu.classList.add("hover-active");
      document.body.classList.add("header_set");
    });

    menu.addEventListener("mouseleave", () => {
      menu.removeAttribute("open");
      menu.classList.remove("hover-active");
      document.body.classList.remove("header_set");
    });
  });
}

// ========== Country/Popup Logic ==========
document.addEventListener("click", function (event) {
  const countryPopup = document.querySelector(".country-popup");
  const bodyPopup = document.querySelector(".popup_body");

  if (event.target.closest(".cp-overlay, .close-popup")) {
    countryPopup?.classList.remove("show-popup");
    document.body.classList.remove("overflow-hidden");
  }

  if (event.target.closest(".site-selector")) {
    countryPopup?.classList.add("show-popup");
    document.body.classList.add("overflow-hidden");
  }

  if (event.target.closest(".popup_main")) {
    bodyPopup?.classList.add("popup_body_show");
    document.body.classList.add("overflow-hidden");
  }

  if (event.target.closest(".popup_close, .popup_back")) {
    bodyPopup?.classList.remove("popup_body_show");
    document.body.classList.remove("overflow-hidden");
  }
});

// ========== ESC Key Close ==========
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelector(".country-popup")?.classList.remove("show-popup");
    document.querySelector(".popup_body")?.classList.remove("popup_body_show");
    document.body.classList.remove("overflow-hidden");

    document.querySelectorAll(".mega-menu[open]").forEach((menu) => {
      menu.removeAttribute("open");
      menu.classList.remove("hover-active");
    });

    document.querySelectorAll(".dropdown-item[open]").forEach((item) => {
      item.removeAttribute("open");
    });

    document.body.classList.remove("header_set");
  }
});
